import React, { useState } from "react";

import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useOnBoarding_Report } from "./OnboardingReport/userOnboardingReport";
import { useGetOrgUnitsData } from "../FSM/Beats_Patches/hooks/useBeat";
import { COLORS } from "../../constants/colors";
import { showToast } from "../../utils/toastUtils";
import { getOnboardingReport } from "./OnboardingReport/OnboardingReportRepo";
import { useExcelPolling } from "../../hooks/useExcelPolling";

const OnboardingReport = () => {
  const {startPolling} = useExcelPolling();
  const [filterData, setFilterData] = useState<any>({ start: 1, length: 10 });
  const [orgUnit, setOrgUnit] = useState("");
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  const [division, setdivision] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endtDate, setEndDate] = useState("");
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");

  const {
    data: dataForObBarding_Report,
    isLoading,
    isSuccess,
  } = useOnBoarding_Report({
    enable: true,
    param: {
      ...(startDate == "" ? {} : { start_date: startDate }),
      ...(endtDate == "" ? {} : { end_date: endtDate }),
      ...(division == "" ? {} : { division: division }),
      start: filterData.start,
      length: filterData.length,
      action: "view",
    },
  });

  const downloadExcelGet = async () => {
    
    const param = {
      ...(startDate == "" ? {} : { start_date: startDate }),
      ...(endtDate == "" ? {} : { end_date: endtDate }),
      ...(division == "" ? {} : { division: division }),
      start: filterData.start,
      length: filterData.length,
      action: "download",
    }
    try {
      setLoadingExcel(true);
      const response = await getOnboardingReport(param);
      const { success, fileDownloadId, intervalTime } =
        response.rowData.data || {};
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (excelStatus: string) => {
            setExcelStatus(excelStatus);
          },
          onSuccess: (url: string) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFaled: (message: string) =>
            showToast.error(message || "onFalied error in OnBoarding  report excel"),
          onExpired: (message: string) =>
            showToast.error(message || "onExpired error in  OnBoarding report excel"),
          onDeleted: (message: string) =>
            showToast.error(message || "onDeleted error in OnBoarding report excel "),
        });
      }
    } catch (error: any) {
      console.log("Error while downloading excel in OnBoarding report");
    }
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
      length: limit,
    }));
  };

  const StartDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStartDate(e.target.value);
  };
  const EndDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndDate(e.target.value);
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Onboarding Report"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        Title="Onboarding Report"
        dynamicHeightOnRowsPerPage={true}
        data={
          (!isLoading && isSuccess && dataForObBarding_Report.formatedData) ||
          []
        }
        showSpinner={isLoading}
        columns={MasReportColoumn}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            <RoundedDropdown
              options={orgUnitsList?.data || []}
              onSelect={(e: any) => setdivision((prev: any) => e.id)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Division"
              headingColor="#2e8dd3"
            />
            {/*  Start Month */}
            <label style={{ color: "black", marginTop: "7px" }}>
              Start Date
            </label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                StartDate(e)
              }
            />

            <label style={{ color: "black", marginTop: "7px" }}>End Date</label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => EndDate(e)}
            />
            {/* <button style={{padding:'6px 10px',borderRadius:'4px',
            backgroundColor:'#2E6DD3' ,border:'none',color:'#fff',
            height:'33px'
            }}>View</button> */}
          </div>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={
          dataForObBarding_Report?.rowData.data?.recordsTotal || 0
        }
      />
    </div>
  );
};

export default OnboardingReport;

const MasReportColoumn = [
  {
    name: "Division Name",
    selector: (row: { UnitName: string }) =>
      row.UnitName ? row.UnitName : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Empolyee Code",
    selector: (row: { EmployeeCode: string }) =>
      row.EmployeeCode ? row.EmployeeCode : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Employee Name",
    selector: (row: { EmployeeName: string }) =>
      row.EmployeeName ? row.EmployeeName : "-",
    sortable: true,
    width: "160px",
    wrap: true,
  },
  {
    name: "Zm Manager Branch",
    selector: (row: { ZmManagerBranch: string }) =>
      row.ZmManagerBranch ? row.ZmManagerBranch : "-",
    sortable: true,
    width: "190px",
    wrap: true,
  },
  {
    name: "Zm Manager Town",
    selector: (row: { ZmManagerTown: string }) =>
      row.ZmManagerTown ? row.ZmManagerTown : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Rm Manager Branch",
    selector: (row: { RmManagerBranch: string }) =>
      row.RmManagerBranch ? row.RmManagerBranch : "-",
    sortable: true,
    width: "190px",
  },
  {
    name: "Rm Manager Town",
    selector: (row: { RmManagerTown: string }) =>
      row.RmManagerTown ? row.RmManagerTown : "-",
    sortable: true,
    wrap: true,
    width: "190px",
  },
  {
    name: "Am Manager",
    selector: (row: { AmManagerBranch: string }) =>
      row.AmManagerBranch ? row.AmManagerBranch : "-",
    sortable: true,
    width: "190px",
  },
  {
    name: "Am Manager Town",
    selector: (row: { AmManagerTown: string }) =>
      row.AmManagerTown ? row.AmManagerTown : "-",
    sortable: true,
    width: "190px",
  },
  {
    name: "Town Name",
    selector: (row: { StownName: string }) =>
      row.StownName ? row.StownName : "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "Beat Name",
    selector: (row: { BeatName: string }) =>
      row.BeatName ? row.BeatName : "-",
    sortable: true,
  },
  {
    name: "Outlet Type",
    selector: (row: { OutletTypeName: string }) =>
      row.OutletTypeName ? row.OutletTypeName : "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "Description",
    selector: (row: { Descriptioin: string }) =>
      row.Descriptioin ? row.Descriptioin : "-",
    sortable: true,
    width: "160px",
  },
];
